import React from 'react';
import { Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import TrimmedMarkdownRender from '@/components/text-editors/TrimmedMarkdownRender';

const WorkspaceRequestConfirmationSuccess = ({ text }) => {
  const intl = useIntl();
  return (
    <>
      <Message
        positive
        className="aridhia-workspace-request-confirmation-success"
        size="small"
        icon="cube"
        header={intl.formatMessage({ id: 'workspace.request.complete.title' })}
        content={intl.formatMessage({ id: 'workspace.request.complete' })}
      />
      <TrimmedMarkdownRender text={text} withMessage />
    </>
  );
};

export default WorkspaceRequestConfirmationSuccess;
